import React from 'react';
import {
  fade,
  ThemeProvider,
  withStyles,
  makeStyles,
  createMuiTheme,
} from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import { green } from '@material-ui/core/colors';

const CssTextField = withStyles({
  root: {
    '& label.Mui-focused': {
      color: '#00c8fc',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#00c8fc',
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#00c8fc',
      },
      '&:hover fieldset': {
        borderColor: '#00c8fc',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#00c8fc',
      },
    },
  },
})(TextField);





const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

const ValidationTextField = withStyles({
  root: {
    '& input:valid + fieldset': {
      borderColor: 'green',
      borderWidth: 2,
    },
    '& input:invalid + fieldset': {
      borderColor: 'red',
      borderWidth: 2,
    },
    '& input:valid:focus + fieldset': {
      borderLeftWidth: 6,
      padding: '4px !important', // override inline-style
    },
  },
})(TextField);

const theme = createMuiTheme({
  palette: {
    primary: {
        main: "#00c8fc"
    },
  },
});

export default function CustomTextField() {
  const classes = useStyles();

  return (
    <div className={classes.root} noValidate>
    </div>
  );
}
